export enum CountryCode {
  AF = 4,
  AL = 8,
  AQ = 10,
  DZ = 12,
  AS = 16,
  AD = 20,
  AO = 24,
  AG = 28,
  AZ = 31,
  AR = 32,
  AU = 36,
  AT = 40,
  BS = 44,
  BH = 48,
  BD = 50,
  AM = 51,
  BB = 52,
  BE = 56,
  BM = 60,
  BT = 64,
  BO = 68,
  BA = 70,
  BW = 72,
  BV = 74,
  BR = 76,
  BZ = 84,
  IO = 86,
  SB = 90,
  VG = 92,
  BN = 96,
  BG = 100,
  MM = 104,
  BI = 108,
  BY = 112,
  KH = 116,
  CM = 120,
  CA = 124,
  CV = 132,
  KY = 136,
  CF = 140,
  LK = 144,
  TD = 148,
  CL = 152,
  CN = 156,
  TW = 158,
  CX = 162,
  CC = 166,
  CO = 170,
  KM = 174,
  YT = 175,
  CG = 178,
  CD = 180,
  CK = 184,
  CR = 188,
  HR = 191,
  CU = 192,
  CY = 196,
  CZ = 203,
  BJ = 204,
  DK = 208,
  DM = 212,
  DO = 214,
  EC = 218,
  SV = 222,
  GQ = 226,
  ET = 231,
  ER = 232,
  EE = 233,
  FO = 234,
  FK = 238,
  GS = 239,
  FJ = 242,
  FI = 246,
  AX = 248,
  FR = 250,
  GF = 254,
  PF = 258,
  TF = 260,
  DJ = 262,
  GA = 266,
  GE = 268,
  GM = 270,
  PS = 275,
  DE = 276,
  GH = 288,
  GI = 292,
  KI = 296,
  GR = 300,
  GL = 304,
  GD = 308,
  GP = 312,
  GU = 316,
  GT = 320,
  GN = 324,
  GY = 328,
  HT = 332,
  HM = 334,
  VA = 336,
  HN = 340,
  HK = 344,
  HU = 348,
  IS = 352,
  IN = 356,
  ID = 360,
  IR = 364,
  IQ = 368,
  IE = 372,
  IL = 376,
  IT = 380,
  CI = 384,
  JM = 388,
  JP = 392,
  KZ = 398,
  JO = 400,
  KE = 404,
  KP = 408,
  KR = 410,
  KW = 414,
  KG = 417,
  LA = 418,
  LB = 422,
  LS = 426,
  LV = 428,
  LR = 430,
  LY = 434,
  LI = 438,
  LT = 440,
  LU = 442,
  MO = 446,
  MG = 450,
  MW = 454,
  MY = 458,
  MV = 462,
  ML = 466,
  MT = 470,
  MQ = 474,
  MR = 478,
  MU = 480,
  MX = 484,
  MC = 492,
  MN = 496,
  MD = 498,
  ME = 499,
  MS = 500,
  MA = 504,
  MZ = 508,
  OM = 512,
  NA = 516,
  NR = 520,
  NP = 524,
  NL = 528,
  CW = 531,
  AW = 533,
  SX = 534,
  BQ = 535,
  NC = 540,
  VU = 548,
  NZ = 554,
  NI = 558,
  NE = 562,
  NG = 566,
  NU = 570,
  NF = 574,
  NO = 578,
  MP = 580,
  UM = 581,
  FM = 583,
  MH = 584,
  PW = 585,
  PK = 586,
  PA = 591,
  PG = 598,
  PY = 600,
  PE = 604,
  PH = 608,
  PN = 612,
  PL = 616,
  PT = 620,
  GW = 624,
  TL = 626,
  PR = 630,
  QA = 634,
  RE = 638,
  RO = 642,
  RU = 643,
  RW = 646,
  BL = 652,
  SH = 654,
  KN = 659,
  AI = 660,
  LC = 662,
  MF = 663,
  PM = 666,
  VC = 670,
  SM = 674,
  ST = 678,
  SA = 682,
  SN = 686,
  RS = 688,
  SC = 690,
  SL = 694,
  SG = 702,
  SK = 703,
  VN = 704,
  SI = 705,
  SO = 706,
  ZA = 710,
  ZW = 716,
  ES = 724,
  SS = 728,
  SD = 729,
  EH = 732,
  SR = 740,
  SJ = 744,
  SZ = 748,
  SE = 752,
  CH = 756,
  SY = 760,
  TJ = 762,
  TH = 764,
  TG = 768,
  TK = 772,
  TO = 776,
  TT = 780,
  AE = 784,
  TN = 788,
  TR = 792,
  TM = 795,
  TC = 796,
  TV = 798,
  UG = 800,
  UA = 804,
  MK = 807,
  EG = 818,
  GB = 826,
  GG = 831,
  JE = 832,
  IM = 833,
  TZ = 834,
  US = 840,
  VI = 850,
  BF = 854,
  UY = 858,
  UZ = 860,
  VE = 862,
  WF = 876,
  WS = 882,
  YE = 887,
  ZM = 894
};

class Countries {
  private readonly map = {} as any;

  constructor() {
    this.map[CountryCode.AF] = { alpha2: "AF", alpha3: "AFG", name: "Afghanistan" };
    this.map[CountryCode.AL] = { alpha2: "AL", alpha3: "ALB", name: "Albania" };
    this.map[CountryCode.AQ] = { alpha2: "AQ", alpha3: "ATA", name: "Antarctica" };
    this.map[CountryCode.DZ] = { alpha2: "DZ", alpha3: "DZA", name: "Algeria" };
    this.map[CountryCode.AS] = { alpha2: "AS", alpha3: "ASM", name: "American Samoa" };
    this.map[CountryCode.AD] = { alpha2: "AD", alpha3: "AND", name: "Andorra" };
    this.map[CountryCode.AO] = { alpha2: "AO", alpha3: "AGO", name: "Angola" };
    this.map[CountryCode.AG] = { alpha2: "AG", alpha3: "ATG", name: "Antigua and Barbuda" };
    this.map[CountryCode.AZ] = { alpha2: "AZ", alpha3: "AZE", name: "Azerbaijan" };
    this.map[CountryCode.AR] = { alpha2: "AR", alpha3: "ARG", name: "Argentina" };
    this.map[CountryCode.AU] = { alpha2: "AU", alpha3: "AUS", name: "Australia" };
    this.map[CountryCode.AT] = { alpha2: "AT", alpha3: "AUT", name: "Austria" };
    this.map[CountryCode.BS] = { alpha2: "BS", alpha3: "BHS", name: "Bahamas" };
    this.map[CountryCode.BH] = { alpha2: "BH", alpha3: "BHR", name: "Bahrain" };
    this.map[CountryCode.BD] = { alpha2: "BD", alpha3: "BGD", name: "Bangladesh" };
    this.map[CountryCode.AM] = { alpha2: "AM", alpha3: "ARM", name: "Armenia" };
    this.map[CountryCode.BB] = { alpha2: "BB", alpha3: "BRB", name: "Barbados" };
    this.map[CountryCode.BE] = { alpha2: "BE", alpha3: "BEL", name: "Belgium" };
    this.map[CountryCode.BM] = { alpha2: "BM", alpha3: "BMU", name: "Bermuda" };
    this.map[CountryCode.BT] = { alpha2: "BT", alpha3: "BTN", name: "Bhutan" };
    this.map[CountryCode.BO] = { alpha2: "BO", alpha3: "BOL", name: "Bolivia, Plurinational State of" };
    this.map[CountryCode.BA] = { alpha2: "BA", alpha3: "BIH", name: "Bosnia and Herzegovina" };
    this.map[CountryCode.BW] = { alpha2: "BW", alpha3: "BWA", name: "Botswana" };
    this.map[CountryCode.BV] = { alpha2: "BV", alpha3: "BVT", name: "Bouvet Island" };
    this.map[CountryCode.BR] = { alpha2: "BR", alpha3: "BRA", name: "Brazil" };
    this.map[CountryCode.BZ] = { alpha2: "BZ", alpha3: "BLZ", name: "Belize" };
    this.map[CountryCode.IO] = { alpha2: "IO", alpha3: "IOT", name: "British Indian Ocean Territory" };
    this.map[CountryCode.SB] = { alpha2: "SB", alpha3: "SLB", name: "Solomon Islands" };
    this.map[CountryCode.VG] = { alpha2: "VG", alpha3: "VGB", name: "Virgin Islands (British)" };
    this.map[CountryCode.BN] = { alpha2: "BN", alpha3: "BRN", name: "Brunei Darussalam" };
    this.map[CountryCode.BG] = { alpha2: "BG", alpha3: "BGR", name: "Bulgaria" };
    this.map[CountryCode.MM] = { alpha2: "MM", alpha3: "MMR", name: "Myanmar" };
    this.map[CountryCode.BI] = { alpha2: "BI", alpha3: "BDI", name: "Burundi" };
    this.map[CountryCode.BY] = { alpha2: "BY", alpha3: "BLR", name: "Belarus" };
    this.map[CountryCode.KH] = { alpha2: "KH", alpha3: "KHM", name: "Cambodia" };
    this.map[CountryCode.CM] = { alpha2: "CM", alpha3: "CMR", name: "Cameroon" };
    this.map[CountryCode.CA] = { alpha2: "CA", alpha3: "CAN", name: "Canada" };
    this.map[CountryCode.CV] = { alpha2: "CV", alpha3: "CPV", name: "Cabo Verde" };
    this.map[CountryCode.KY] = { alpha2: "KY", alpha3: "CYM", name: "Cayman Islands" };
    this.map[CountryCode.CF] = { alpha2: "CF", alpha3: "CAF", name: "Central African Republic" };
    this.map[CountryCode.LK] = { alpha2: "LK", alpha3: "LKA", name: "Sri Lanka" };
    this.map[CountryCode.TD] = { alpha2: "TD", alpha3: "TCD", name: "Chad" };
    this.map[CountryCode.CL] = { alpha2: "CL", alpha3: "CHL", name: "Chile" };
    this.map[CountryCode.CN] = { alpha2: "CN", alpha3: "CHN", name: "China" };
    this.map[CountryCode.TW] = { alpha2: "TW", alpha3: "TWN", name: "Taiwan, Province of China" };
    this.map[CountryCode.CX] = { alpha2: "CX", alpha3: "CXR", name: "Christmas Island" };
    this.map[CountryCode.CC] = { alpha2: "CC", alpha3: "CCK", name: "Cocos (Keeling) Islands" };
    this.map[CountryCode.CO] = { alpha2: "CO", alpha3: "COL", name: "Colombia" };
    this.map[CountryCode.KM] = { alpha2: "KM", alpha3: "COM", name: "Comoros" };
    this.map[CountryCode.YT] = { alpha2: "YT", alpha3: "MYT", name: "Mayotte" };
    this.map[CountryCode.CG] = { alpha2: "CG", alpha3: "COG", name: "Congo" };
    this.map[CountryCode.CD] = { alpha2: "CD", alpha3: "COD", name: "Congo, Democratic Republic of the" };
    this.map[CountryCode.CK] = { alpha2: "CK", alpha3: "COK", name: "Cook Islands" };
    this.map[CountryCode.CR] = { alpha2: "CR", alpha3: "CRI", name: "Costa Rica" };
    this.map[CountryCode.HR] = { alpha2: "HR", alpha3: "HRV", name: "Croatia" };
    this.map[CountryCode.CU] = { alpha2: "CU", alpha3: "CUB", name: "Cuba" };
    this.map[CountryCode.CY] = { alpha2: "CY", alpha3: "CYP", name: "Cyprus" };
    this.map[CountryCode.CZ] = { alpha2: "CZ", alpha3: "CZE", name: "Czechia" };
    this.map[CountryCode.BJ] = { alpha2: "BJ", alpha3: "BEN", name: "Benin" };
    this.map[CountryCode.DK] = { alpha2: "DK", alpha3: "DNK", name: "Denmark" };
    this.map[CountryCode.DM] = { alpha2: "DM", alpha3: "DMA", name: "Dominica" };
    this.map[CountryCode.DO] = { alpha2: "DO", alpha3: "DOM", name: "Dominican Republic" };
    this.map[CountryCode.EC] = { alpha2: "EC", alpha3: "ECU", name: "Ecuador" };
    this.map[CountryCode.SV] = { alpha2: "SV", alpha3: "SLV", name: "El Salvador" };
    this.map[CountryCode.GQ] = { alpha2: "GQ", alpha3: "GNQ", name: "Equatorial Guinea" };
    this.map[CountryCode.ET] = { alpha2: "ET", alpha3: "ETH", name: "Ethiopia" };
    this.map[CountryCode.ER] = { alpha2: "ER", alpha3: "ERI", name: "Eritrea" };
    this.map[CountryCode.EE] = { alpha2: "EE", alpha3: "EST", name: "Estonia" };
    this.map[CountryCode.FO] = { alpha2: "FO", alpha3: "FRO", name: "Faroe Islands" };
    this.map[CountryCode.FK] = { alpha2: "FK", alpha3: "FLK", name: "Falkland Islands (Malvinas)" };
    this.map[CountryCode.GS] = { alpha2: "GS", alpha3: "SGS", name: "South Georgia and the South Sandwich Islands" };
    this.map[CountryCode.FJ] = { alpha2: "FJ", alpha3: "FJI", name: "Fiji" };
    this.map[CountryCode.FI] = { alpha2: "FI", alpha3: "FIN", name: "Finland" };
    this.map[CountryCode.AX] = { alpha2: "AX", alpha3: "ALA", name: "Åland Islands" };
    this.map[CountryCode.FR] = { alpha2: "FR", alpha3: "FRA", name: "France" };
    this.map[CountryCode.GF] = { alpha2: "GF", alpha3: "GUF", name: "French Guiana" };
    this.map[CountryCode.PF] = { alpha2: "PF", alpha3: "PYF", name: "French Polynesia" };
    this.map[CountryCode.TF] = { alpha2: "TF", alpha3: "ATF", name: "French Southern Territories" };
    this.map[CountryCode.DJ] = { alpha2: "DJ", alpha3: "DJI", name: "Djibouti" };
    this.map[CountryCode.GA] = { alpha2: "GA", alpha3: "GAB", name: "Gabon" };
    this.map[CountryCode.GE] = { alpha2: "GE", alpha3: "GEO", name: "Georgia" };
    this.map[CountryCode.GM] = { alpha2: "GM", alpha3: "GMB", name: "Gambia" };
    this.map[CountryCode.PS] = { alpha2: "PS", alpha3: "PSE", name: "Palestine, State of" };
    this.map[CountryCode.DE] = { alpha2: "DE", alpha3: "DEU", name: "Germany" };
    this.map[CountryCode.GH] = { alpha2: "GH", alpha3: "GHA", name: "Ghana" };
    this.map[CountryCode.GI] = { alpha2: "GI", alpha3: "GIB", name: "Gibraltar" };
    this.map[CountryCode.KI] = { alpha2: "KI", alpha3: "KIR", name: "Kiribati" };
    this.map[CountryCode.GR] = { alpha2: "GR", alpha3: "GRC", name: "Greece" };
    this.map[CountryCode.GL] = { alpha2: "GL", alpha3: "GRL", name: "Greenland" };
    this.map[CountryCode.GD] = { alpha2: "GD", alpha3: "GRD", name: "Grenada" };
    this.map[CountryCode.GP] = { alpha2: "GP", alpha3: "GLP", name: "Guadeloupe" };
    this.map[CountryCode.GU] = { alpha2: "GU", alpha3: "GUM", name: "Guam" };
    this.map[CountryCode.GT] = { alpha2: "GT", alpha3: "GTM", name: "Guatemala" };
    this.map[CountryCode.GN] = { alpha2: "GN", alpha3: "GIN", name: "Guinea" };
    this.map[CountryCode.GY] = { alpha2: "GY", alpha3: "GUY", name: "Guyana" };
    this.map[CountryCode.HT] = { alpha2: "HT", alpha3: "HTI", name: "Haiti" };
    this.map[CountryCode.HM] = { alpha2: "HM", alpha3: "HMD", name: "Heard Island and McDonald Islands" };
    this.map[CountryCode.VA] = { alpha2: "VA", alpha3: "VAT", name: "Holy See" };
    this.map[CountryCode.HN] = { alpha2: "HN", alpha3: "HND", name: "Honduras" };
    this.map[CountryCode.HK] = { alpha2: "HK", alpha3: "HKG", name: "Hong Kong" };
    this.map[CountryCode.HU] = { alpha2: "HU", alpha3: "HUN", name: "Hungary" };
    this.map[CountryCode.IS] = { alpha2: "IS", alpha3: "ISL", name: "Iceland" };
    this.map[CountryCode.IN] = { alpha2: "IN", alpha3: "IND", name: "India" };
    this.map[CountryCode.ID] = { alpha2: "ID", alpha3: "IDN", name: "Indonesia" };
    this.map[CountryCode.IR] = { alpha2: "IR", alpha3: "IRN", name: "Iran, Islamic Republic of" };
    this.map[CountryCode.IQ] = { alpha2: "IQ", alpha3: "IRQ", name: "Iraq" };
    this.map[CountryCode.IE] = { alpha2: "IE", alpha3: "IRL", name: "Ireland" };
    this.map[CountryCode.IL] = { alpha2: "IL", alpha3: "ISR", name: "Israel" };
    this.map[CountryCode.IT] = { alpha2: "IT", alpha3: "ITA", name: "Italy" };
    this.map[CountryCode.CI] = { alpha2: "CI", alpha3: "CIV", name: "Côte d'Ivoire" };
    this.map[CountryCode.JM] = { alpha2: "JM", alpha3: "JAM", name: "Jamaica" };
    this.map[CountryCode.JP] = { alpha2: "JP", alpha3: "JPN", name: "Japan" };
    this.map[CountryCode.KZ] = { alpha2: "KZ", alpha3: "KAZ", name: "Kazakhstan" };
    this.map[CountryCode.JO] = { alpha2: "JO", alpha3: "JOR", name: "Jordan" };
    this.map[CountryCode.KE] = { alpha2: "KE", alpha3: "KEN", name: "Kenya" };
    this.map[CountryCode.KP] = { alpha2: "KP", alpha3: "PRK", name: "Korea, Democratic People's Republic of" };
    this.map[CountryCode.KR] = { alpha2: "KR", alpha3: "KOR", name: "Korea, Republic of" };
    this.map[CountryCode.KW] = { alpha2: "KW", alpha3: "KWT", name: "Kuwait" };
    this.map[CountryCode.KG] = { alpha2: "KG", alpha3: "KGZ", name: "Kyrgyzstan" };
    this.map[CountryCode.LA] = { alpha2: "LA", alpha3: "LAO", name: "Lao People's Democratic Republic" };
    this.map[CountryCode.LB] = { alpha2: "LB", alpha3: "LBN", name: "Lebanon" };
    this.map[CountryCode.LS] = { alpha2: "LS", alpha3: "LSO", name: "Lesotho" };
    this.map[CountryCode.LV] = { alpha2: "LV", alpha3: "LVA", name: "Latvia" };
    this.map[CountryCode.LR] = { alpha2: "LR", alpha3: "LBR", name: "Liberia" };
    this.map[CountryCode.LY] = { alpha2: "LY", alpha3: "LBY", name: "Libya" };
    this.map[CountryCode.LI] = { alpha2: "LI", alpha3: "LIE", name: "Liechtenstein" };
    this.map[CountryCode.LT] = { alpha2: "LT", alpha3: "LTU", name: "Lithuania" };
    this.map[CountryCode.LU] = { alpha2: "LU", alpha3: "LUX", name: "Luxembourg" };
    this.map[CountryCode.MO] = { alpha2: "MO", alpha3: "MAC", name: "Macao" };
    this.map[CountryCode.MG] = { alpha2: "MG", alpha3: "MDG", name: "Madagascar" };
    this.map[CountryCode.MW] = { alpha2: "MW", alpha3: "MWI", name: "Malawi" };
    this.map[CountryCode.MY] = { alpha2: "MY", alpha3: "MYS", name: "Malaysia" };
    this.map[CountryCode.MV] = { alpha2: "MV", alpha3: "MDV", name: "Maldives" };
    this.map[CountryCode.ML] = { alpha2: "ML", alpha3: "MLI", name: "Mali" };
    this.map[CountryCode.MT] = { alpha2: "MT", alpha3: "MLT", name: "Malta" };
    this.map[CountryCode.MQ] = { alpha2: "MQ", alpha3: "MTQ", name: "Martinique" };
    this.map[CountryCode.MR] = { alpha2: "MR", alpha3: "MRT", name: "Mauritania" };
    this.map[CountryCode.MU] = { alpha2: "MU", alpha3: "MUS", name: "Mauritius" };
    this.map[CountryCode.MX] = { alpha2: "MX", alpha3: "MEX", name: "Mexico" };
    this.map[CountryCode.MC] = { alpha2: "MC", alpha3: "MCO", name: "Monaco" };
    this.map[CountryCode.MN] = { alpha2: "MN", alpha3: "MNG", name: "Mongolia" };
    this.map[CountryCode.MD] = { alpha2: "MD", alpha3: "MDA", name: "Moldova, Republic of" };
    this.map[CountryCode.ME] = { alpha2: "ME", alpha3: "MNE", name: "Montenegro" };
    this.map[CountryCode.MS] = { alpha2: "MS", alpha3: "MSR", name: "Montserrat" };
    this.map[CountryCode.MA] = { alpha2: "MA", alpha3: "MAR", name: "Morocco" };
    this.map[CountryCode.MZ] = { alpha2: "MZ", alpha3: "MOZ", name: "Mozambique" };
    this.map[CountryCode.OM] = { alpha2: "OM", alpha3: "OMN", name: "Oman" };
    this.map[CountryCode.NA] = { alpha2: "NA", alpha3: "NAM", name: "Namibia" };
    this.map[CountryCode.NR] = { alpha2: "NR", alpha3: "NRU", name: "Nauru" };
    this.map[CountryCode.NP] = { alpha2: "NP", alpha3: "NPL", name: "Nepal" };
    this.map[CountryCode.NL] = { alpha2: "NL", alpha3: "NLD", name: "Netherlands, Kingdom of the" };
    this.map[CountryCode.CW] = { alpha2: "CW", alpha3: "CUW", name: "Curaçao" };
    this.map[CountryCode.AW] = { alpha2: "AW", alpha3: "ABW", name: "Aruba" };
    this.map[CountryCode.SX] = { alpha2: "SX", alpha3: "SXM", name: "Sint Maarten (Dutch part)" };
    this.map[CountryCode.BQ] = { alpha2: "BQ", alpha3: "BES", name: "Bonaire, Sint Eustatius and Saba" };
    this.map[CountryCode.NC] = { alpha2: "NC", alpha3: "NCL", name: "New Caledonia" };
    this.map[CountryCode.VU] = { alpha2: "VU", alpha3: "VUT", name: "Vanuatu" };
    this.map[CountryCode.NZ] = { alpha2: "NZ", alpha3: "NZL", name: "New Zealand" };
    this.map[CountryCode.NI] = { alpha2: "NI", alpha3: "NIC", name: "Nicaragua" };
    this.map[CountryCode.NE] = { alpha2: "NE", alpha3: "NER", name: "Niger" };
    this.map[CountryCode.NG] = { alpha2: "NG", alpha3: "NGA", name: "Nigeria" };
    this.map[CountryCode.NU] = { alpha2: "NU", alpha3: "NIU", name: "Niue" };
    this.map[CountryCode.NF] = { alpha2: "NF", alpha3: "NFK", name: "Norfolk Island" };
    this.map[CountryCode.NO] = { alpha2: "NO", alpha3: "NOR", name: "Norway" };
    this.map[CountryCode.MP] = { alpha2: "MP", alpha3: "MNP", name: "Northern Mariana Islands" };
    this.map[CountryCode.UM] = { alpha2: "UM", alpha3: "UMI", name: "United States Minor Outlying Islands" };
    this.map[CountryCode.FM] = { alpha2: "FM", alpha3: "FSM", name: "Micronesia, Federated States of" };
    this.map[CountryCode.MH] = { alpha2: "MH", alpha3: "MHL", name: "Marshall Islands" };
    this.map[CountryCode.PW] = { alpha2: "PW", alpha3: "PLW", name: "Palau" };
    this.map[CountryCode.PK] = { alpha2: "PK", alpha3: "PAK", name: "Pakistan" };
    this.map[CountryCode.PA] = { alpha2: "PA", alpha3: "PAN", name: "Panama" };
    this.map[CountryCode.PG] = { alpha2: "PG", alpha3: "PNG", name: "Papua New Guinea" };
    this.map[CountryCode.PY] = { alpha2: "PY", alpha3: "PRY", name: "Paraguay" };
    this.map[CountryCode.PE] = { alpha2: "PE", alpha3: "PER", name: "Peru" };
    this.map[CountryCode.PH] = { alpha2: "PH", alpha3: "PHL", name: "Philippines" };
    this.map[CountryCode.PN] = { alpha2: "PN", alpha3: "PCN", name: "Pitcairn" };
    this.map[CountryCode.PL] = { alpha2: "PL", alpha3: "POL", name: "Poland" };
    this.map[CountryCode.PT] = { alpha2: "PT", alpha3: "PRT", name: "Portugal" };
    this.map[CountryCode.GW] = { alpha2: "GW", alpha3: "GNB", name: "Guinea-Bissau" };
    this.map[CountryCode.TL] = { alpha2: "TL", alpha3: "TLS", name: "Timor-Leste" };
    this.map[CountryCode.PR] = { alpha2: "PR", alpha3: "PRI", name: "Puerto Rico" };
    this.map[CountryCode.QA] = { alpha2: "QA", alpha3: "QAT", name: "Qatar" };
    this.map[CountryCode.RE] = { alpha2: "RE", alpha3: "REU", name: "Réunion" };
    this.map[CountryCode.RO] = { alpha2: "RO", alpha3: "ROU", name: "Romania" };
    this.map[CountryCode.RU] = { alpha2: "RU", alpha3: "RUS", name: "Russian Federation" };
    this.map[CountryCode.RW] = { alpha2: "RW", alpha3: "RWA", name: "Rwanda" };
    this.map[CountryCode.BL] = { alpha2: "BL", alpha3: "BLM", name: "Saint Barthélemy" };
    this.map[CountryCode.SH] = { alpha2: "SH", alpha3: "SHN", name: "Saint Helena, Ascension and Tristan da Cunha" };
    this.map[CountryCode.KN] = { alpha2: "KN", alpha3: "KNA", name: "Saint Kitts and Nevis" };
    this.map[CountryCode.AI] = { alpha2: "AI", alpha3: "AIA", name: "Anguilla" };
    this.map[CountryCode.LC] = { alpha2: "LC", alpha3: "LCA", name: "Saint Lucia" };
    this.map[CountryCode.MF] = { alpha2: "MF", alpha3: "MAF", name: "Saint Martin (French part)" };
    this.map[CountryCode.PM] = { alpha2: "PM", alpha3: "SPM", name: "Saint Pierre and Miquelon" };
    this.map[CountryCode.VC] = { alpha2: "VC", alpha3: "VCT", name: "Saint Vincent and the Grenadines" };
    this.map[CountryCode.SM] = { alpha2: "SM", alpha3: "SMR", name: "San Marino" };
    this.map[CountryCode.ST] = { alpha2: "ST", alpha3: "STP", name: "Sao Tome and Principe" };
    this.map[CountryCode.SA] = { alpha2: "SA", alpha3: "SAU", name: "Saudi Arabia" };
    this.map[CountryCode.SN] = { alpha2: "SN", alpha3: "SEN", name: "Senegal" };
    this.map[CountryCode.RS] = { alpha2: "RS", alpha3: "SRB", name: "Serbia" };
    this.map[CountryCode.SC] = { alpha2: "SC", alpha3: "SYC", name: "Seychelles" };
    this.map[CountryCode.SL] = { alpha2: "SL", alpha3: "SLE", name: "Sierra Leone" };
    this.map[CountryCode.SG] = { alpha2: "SG", alpha3: "SGP", name: "Singapore" };
    this.map[CountryCode.SK] = { alpha2: "SK", alpha3: "SVK", name: "Slovakia" };
    this.map[CountryCode.VN] = { alpha2: "VN", alpha3: "VNM", name: "Viet Nam" };
    this.map[CountryCode.SI] = { alpha2: "SI", alpha3: "SVN", name: "Slovenia" };
    this.map[CountryCode.SO] = { alpha2: "SO", alpha3: "SOM", name: "Somalia" };
    this.map[CountryCode.ZA] = { alpha2: "ZA", alpha3: "ZAF", name: "South Africa" };
    this.map[CountryCode.ZW] = { alpha2: "ZW", alpha3: "ZWE", name: "Zimbabwe" };
    this.map[CountryCode.ES] = { alpha2: "ES", alpha3: "ESP", name: "Spain" };
    this.map[CountryCode.SS] = { alpha2: "SS", alpha3: "SSD", name: "South Sudan" };
    this.map[CountryCode.SD] = { alpha2: "SD", alpha3: "SDN", name: "Sudan" };
    this.map[CountryCode.EH] = { alpha2: "EH", alpha3: "ESH", name: "Western Sahara" };
    this.map[CountryCode.SR] = { alpha2: "SR", alpha3: "SUR", name: "Suriname" };
    this.map[CountryCode.SJ] = { alpha2: "SJ", alpha3: "SJM", name: "Svalbard and Jan Mayen" };
    this.map[CountryCode.SZ] = { alpha2: "SZ", alpha3: "SWZ", name: "Eswatini" };
    this.map[CountryCode.SE] = { alpha2: "SE", alpha3: "SWE", name: "Sweden" };
    this.map[CountryCode.CH] = { alpha2: "CH", alpha3: "CHE", name: "Switzerland" };
    this.map[CountryCode.SY] = { alpha2: "SY", alpha3: "SYR", name: "Syrian Arab Republic" };
    this.map[CountryCode.TJ] = { alpha2: "TJ", alpha3: "TJK", name: "Tajikistan" };
    this.map[CountryCode.TH] = { alpha2: "TH", alpha3: "THA", name: "Thailand" };
    this.map[CountryCode.TG] = { alpha2: "TG", alpha3: "TGO", name: "Togo" };
    this.map[CountryCode.TK] = { alpha2: "TK", alpha3: "TKL", name: "Tokelau" };
    this.map[CountryCode.TO] = { alpha2: "TO", alpha3: "TON", name: "Tonga" };
    this.map[CountryCode.TT] = { alpha2: "TT", alpha3: "TTO", name: "Trinidad and Tobago" };
    this.map[CountryCode.AE] = { alpha2: "AE", alpha3: "ARE", name: "United Arab Emirates" };
    this.map[CountryCode.TN] = { alpha2: "TN", alpha3: "TUN", name: "Tunisia" };
    this.map[CountryCode.TR] = { alpha2: "TR", alpha3: "TUR", name: "Türkiye" };
    this.map[CountryCode.TM] = { alpha2: "TM", alpha3: "TKM", name: "Turkmenistan" };
    this.map[CountryCode.TC] = { alpha2: "TC", alpha3: "TCA", name: "Turks and Caicos Islands" };
    this.map[CountryCode.TV] = { alpha2: "TV", alpha3: "TUV", name: "Tuvalu" };
    this.map[CountryCode.UG] = { alpha2: "UG", alpha3: "UGA", name: "Uganda" };
    this.map[CountryCode.UA] = { alpha2: "UA", alpha3: "UKR", name: "Ukraine" };
    this.map[CountryCode.MK] = { alpha2: "MK", alpha3: "MKD", name: "North Macedonia" };
    this.map[CountryCode.EG] = { alpha2: "EG", alpha3: "EGY", name: "Egypt" };
    this.map[CountryCode.GB] = { alpha2: "GB", alpha3: "GBR", name: "United Kingdom" };
    this.map[CountryCode.GG] = { alpha2: "GG", alpha3: "GGY", name: "Guernsey" };
    this.map[CountryCode.JE] = { alpha2: "JE", alpha3: "JEY", name: "Jersey" };
    this.map[CountryCode.IM] = { alpha2: "IM", alpha3: "IMN", name: "Isle of Man" };
    this.map[CountryCode.TZ] = { alpha2: "TZ", alpha3: "TZA", name: "Tanzania, United Republic of" };
    this.map[CountryCode.US] = { alpha2: "US", alpha3: "USA", name: "United States of America" };
    this.map[CountryCode.VI] = { alpha2: "VI", alpha3: "VIR", name: "Virgin Islands (U.S.)" };
    this.map[CountryCode.BF] = { alpha2: "BF", alpha3: "BFA", name: "Burkina Faso" };
    this.map[CountryCode.UY] = { alpha2: "UY", alpha3: "URY", name: "Uruguay" };
    this.map[CountryCode.UZ] = { alpha2: "UZ", alpha3: "UZB", name: "Uzbekistan" };
    this.map[CountryCode.VE] = { alpha2: "VE", alpha3: "VEN", name: "Venezuela, Bolivarian Republic of" };
    this.map[CountryCode.WF] = { alpha2: "WF", alpha3: "WLF", name: "Wallis and Futuna" };
    this.map[CountryCode.WS] = { alpha2: "WS", alpha3: "WSM", name: "Samoa" };
    this.map[CountryCode.YE] = { alpha2: "YE", alpha3: "YEM", name: "Yemen" };
    this.map[CountryCode.ZM] = { alpha2: "ZM", alpha3: "ZMB", name: "Zambia" };
  }

  country = (code: CountryCode) => {
    return this.map[code] || undefined;
  };
}

export const { country } = new Countries();